<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 17:59:10
 * @FilePath: \qctsw-vue\packages\app\src\pages\news\classification.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import Menu from './components/Menu.vue'
import { logicNewsColumnPage } from '@/logic/news/page'

const {
  columnId,
  page,
  data,
  pagination,
  getNewsPage,
  state,
} = logicNewsColumnPage()

await getNewsPage(page.value)

function getMore() {
  const pageNum = pagination.pagination.page + 1
  getNewsPage(pageNum)
}
</script>

<template>
  <div class="public-container max-w-275">
    <Menu />
    <div class="flex pb-4xl">
      <div class="flex-grow pt-sm">
        <UtilLoadState :state="state" :length="data.length" type="up" :reload-handler="() => getNewsPage(page)">
          <template #loading>
            <SkeletonArticle v-for="v in 10" :key="v" mb-sm />
          </template>
          <template v-if="data && data.length">
            <baseList :state="state" @load="getMore">
              <ArticleItem v-for="(val, idx) in data" :key="idx" :item="val" class="mb-sm pb-sm border-b-1 border-slate-1" />
            </baseList>
          </template>
          <BasicEmpty v-else />
        </UtilLoadState>
        <!-- <BasicPagination
          v-if="pagination.pagination.pageCount"
          class="mt-xl"
          :page="pagination.pagination.page"
          :total="pagination.pagination.pageCount"
          :to="(page) => APP_ROUTER.newsClass({ id: columnId, page })"
        /> -->
      </div>
      <div class="flex-shrink-0 w-[calc(100%-47rem)] pl-xl">
        <RankHotNews class="sticky top-39" />
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
